import { emptySplitApi as api } from "./emptyApi"
import {
  BudgetUpdateCadenceControllerGetCadenceApiResponse,
  BudgetUpdateCadenceControllerGetCadenceApiArg,
  BudgetUpdateCadenceControllerUpsertCadenceApiResponse,
  BudgetUpdateCadenceControllerUpsertCadenceApiArg,
} from "./types/budget-update-cadence.types"

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    budgetUpdateCadenceControllerGetCadence: build.query<
      BudgetUpdateCadenceControllerGetCadenceApiResponse,
      BudgetUpdateCadenceControllerGetCadenceApiArg
    >({
      query: () => ({ url: `/budget-update-cadence` }),
      providesTags: ["BudgetUpdateCadence"],
    }),
    budgetUpdateCadenceControllerUpsertCadence: build.mutation<
      BudgetUpdateCadenceControllerUpsertCadenceApiResponse,
      BudgetUpdateCadenceControllerUpsertCadenceApiArg
    >({
      query: queryArg => ({
        url: `/budget-update-cadence`,
        method: "PUT",
        body: queryArg.upsertBudgetUpdateCadenceDto,
      }),
      invalidatesTags: ["BudgetUpdateCadence"],
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as generatedApi }

// Export hooks
export const {
  useBudgetUpdateCadenceControllerGetCadenceQuery,
  useBudgetUpdateCadenceControllerUpsertCadenceMutation,
} = injectedRtkApi

// Re-export types that are needed by components
export type {
  BudgetUpdateCadenceDto,
  BudgetUpdateCadenceSlotDto,
  UpsertBudgetUpdateCadenceDto,
  UpsertBudgetUpdateCadenceSlotDto,
} from "./types/budget-update-cadence.types"
